var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.box},[_c('p',[_vm._v(" "+_vm._s(_vm.text || 'No Data Found')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }